import React from 'react';
import { Badge, Group } from '@mantine/core';

const STATUS_TONES = {
	ACT: {
		background: '#0f766e',
		color: '#ffffff',
		border: '1px solid #0f766e',
	},
	NOP: {
		background: '#475569',
		color: '#f8fafc',
		border: '1px solid #334155',
	},
	other: {
		background: '#3730a3',
		color: '#eef2ff',
		border: '1px solid #4338ca',
	},
	unknown: {
		background: '#ffedd5',
		color: '#9a3412',
		border: '1px solid #f97316',
	},
	disabled: {
		label: 'Deshabilitado',
		title: 'Deshabilitado',
		background: '#9f1239',
		color: '#fff1f2',
		border: '1px solid #9f1239',
	},
};

function toneFor(statusCode) {
	if (statusCode === 'ACT') {
		return STATUS_TONES.ACT;
	}
	if (statusCode === 'NOP') {
		return STATUS_TONES.NOP;
	}
	if (statusCode) {
		return STATUS_TONES.other;
	}
	return STATUS_TONES.unknown;
}

export function statusBadgeItems({
	statusCode,
	statusName,
	disabled = false,
} = {}) {
	const label = statusName || (statusCode ? statusCode : 'Sin estado');
	const items = [
		{
			label,
			title: label,
			...toneFor(statusCode),
		},
	];
	if (disabled) {
		items.push({ ...STATUS_TONES.disabled });
	}
	return items;
}

function StatusChip({ item }) {
	return (
		<Badge
			size='sm'
			radius='sm'
			variant='filled'
			title={item.title}
			aria-label={item.title}
			styles={{
				root: {
					textTransform: 'none',
					fontWeight: 700,
					letterSpacing: '0.02em',
					backgroundColor: item.background,
					color: item.color,
					border: item.border,
				},
			}}
		>
			{item.label}
		</Badge>
	);
}

export function EstablishmentStatusBadge({
	statusCode,
	statusName,
	disabled = false,
}) {
	const items = statusBadgeItems({ statusCode, statusName, disabled });
	return (
		<Group spacing={6} noWrap>
			{items.map(item => (
				<StatusChip key={item.label} item={item} />
			))}
		</Group>
	);
}
